/**
 * To know the status of the background layer
 * @typedef {Object} gmfBackgroundlayerStatus
 * @property {boolean} touchedByUser Is the background layer (potentially) manually set by the user ?
 */
export const gmfBackgroundlayerStatus = {
  touchedByUser: false,
};
